(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('RptTemplateSearch', RptTemplateSearch);

    RptTemplateSearch.$inject = ['$resource'];

    function RptTemplateSearch($resource) {
        var resourceUrl =  'api/_search/rpt-templates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
